// src/data/texts.js

export const skillsText = `Tools that I use:
- VSCode
  Mostly to code websites and command-line interface applications.
- Git
  Helps to manage my projects and collaborate with other programmers.
- Docker
  Easily sends a project to anyone without causing errors.

Frameworks that I use:
- Laravel, ReactJS.

Languages that I use:
- JavaScript, PHP, Lua.

Databases that I use:
- MySQL/MariaDB, MongoDB, Text files, JSON.

Architectures:
- RESTful API, OOP.
`;

export const welcomeText = `This website is designed to mimic a desktop environment where users can interact with various elements such as folders, files, and links.

Features:
- Double-click to open folders and files.
- Supports images, videos, text files, and links.
- Resize windows by dragging the bottom right corner.
- A taskbar that tracks open windows.
- Switch between English and Indonesian using the language button on the taskbar.
- Terminal emulator with basic commands (cd, ls, cat, clear, help)

This project is a demonstration of a modern web-based desktop interface, combining React and Tailwind CSS to create a fluid and interactive user experience.

Regards,
Roza.
`;

export const aboutwebsiteText = `The website is made using create-react-app framework and TailwindCSS.
most of the time I spent coding on this project is the file system and Window Container handling,
so I am quite proud with this project since I made most of structure within 2 days and I still plan to further extend features on this website:

Future ideas for this website
- ContextMenu (you can create folder and txt file with this, also delete it.)
- Mobile Support (when using mobile to access this site, it will emulate android/ios feeling.)
- Add Terminal (the one in the taskbar is still place holder.)

You can contact me on Discord : shiniya_

`;

export const infoText = `My name is Roza.
I prefer using PHP to make sites (especially with Laravel framework.
My hobbies were reading or writing stories, tinkering with software and contributing to people's repositories.

I love developing front end with React (I dont like NextJS somehow but plan on learning it)

Currently using Arch Linux (Manjaro) as Daily Driver and I love it!
Discord : shiniya_`;

export const changelogText = `Changelog:
  26/08/2024
  - Add localization.
  - Fixed a problem where the transform position on decimal will blur the window (thanks math.round)
  - Change the style of taskbar and File Manager and renamed it to Thunar
  28/08/2024
  - Add DateTime to Taskbar
  21/02/2025
  - Make icon wrap similiar to Windows icon behavior
  - Separate File Explorer and .exe handler
  - Add terminal and make the virtual FS to parse initalFilesystem
  - Parse filesystem directly so we could access it and modify it for future
  - probably gonna add mkdir and nano commands
  17/05/2025
  - Fixed folder navigation to properly open specific folders when clicked from the desktop
  - Improved path handling in FileExplorer component
  - Refactor code to make it more readable and maintainable
  23/09/2025
  - Added informational content for project .txt files (info-tefaren.txt, info-wn.txt, info-news.txt, info-pt.txt)
  - Updated text mappings in FileUtils to support localized project descriptions
  `;

export const infoTefarenText = `TEFAREN is a project developed with modern web technologies aimed for borrowing and returning items.
Project Details:
- Built with React and other modern frameworks
- Deployed on Vercel platform

Link: https://fe-tefaren-v2.vercel.app/
`;

export const infoWnText = `Webnovel AI Translation project focuses on using artificial intelligence to translate webnovels efficiently. It includes tools for automated translation and quality improvement. Honestly, this project is more for personal use as I am a webnovel reader and writer.

Project Features:
- AI-powered translation engine
- Support for multiple languages
- Quality assessment tools
- Batch processing capabilities

This project demonstrates the integration of AI in content translation workflows.
`;

export const infoNewsText = `Skatel News Mobile is a Flutter-based mobile application for news aggregation. It provides users with the latest news updates in a user-friendly interface.

App Features:
- Real-time news updates
- Category-based news filtering
- Offline reading capability
- Push notifications
- Built with Flutter for cross-platform compatibility

Video demonstration available in the project folder.
`;

export const infoPtText = `CV TUNAS KEMBANG DJATI is a trusted construction contractor based in Banjarbaru, specializing in building construction and civil engineering projects.

Company Overview:
- Founded: July 21, 2022
- Locations: Banjarbaru, Sidoarjo, Malang
- Team: 20+ professional members with 3+ years of experience

Services:
- Moulding Fabrication (precision and high-quality)
- Infrastructure & Buildings construction
- Industrial Engineering solutions

Achievements:
- 100+ successfully completed projects
- Certified with 6 international ISO standards (9001, 14001, 45001, 22000, 27001, 37001)
- Commitment to environmental sustainability and safety (SMK3 PP 50/2012)

This is a commissioned project for the company's profile website.

Website: https://teknikrekayasaindustri.co.id/
`;

export const infoPortoText = `This is my old portfolio website, an earlier version showcasing my work as a web developer and 3D artist.

Portfolio Features:
- Personal introduction with contact information
- Comprehensive tech stack display
- Education background
- GitHub projects showcase
- Featured projects including TEFAREN and E-Commerce Kardus
- Blog posts on Medium

This portfolio represents my early web development work and skills demonstration.

Link: https://fthlrzi.vercel.app/
`;

export const sitekalasText = `Commisioned project.
- Calculate and summarize all files in one document.
- Made with Javascript and Laravel
`;